"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareButton = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ShareButton = (function (_super) {
    __extends(ShareButton, _super);
    function ShareButton(props) {
        return _super.call(this, props) || this;
    }
    ShareButton.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(kaleidoscope_1.CopyToClipboard, { value: this.props.linkUrl, showTooltipOnCopy: true }, function (_a) {
            var onCopy = _a.onCopy;
            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "Set the project 'LIVE' to share it", wrapTarget: true, show: _this.props.disabled ? undefined : false, position: kaleidoscope_1.TooltipPosition.Bottom },
                react_1.default.createElement(kaleidoscope_1.Button, { disabled: _this.props.disabled, width: "full", onClick: function () {
                        onCopy();
                        _this.props.telemetryCallback();
                    }, className: "space-stack-s" },
                    react_1.default.createElement(icons_1.Link, null),
                    "Copy shareable link")));
        }));
    };
    return ShareButton;
}(react_1.default.Component));
exports.ShareButton = ShareButton;
